// Need for fix case when videos don't autoplay when battery safe mode enabled

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if (isSafari) {
  window.addEventListener("DOMContentLoaded", () => {
    const videoEls = document.querySelectorAll("video");

    window.addEventListener("touchstart", () => {
      videoEls.forEach(video => video.play());
    }, { once: true });
  })
}
